import { boot } from 'quasar/wrappers'
import axios from 'axios'
import { config } from './config'
import { empty } from 'src/utils/variables'
import { i18n } from 'boot/i18n'
import qs from 'qs'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({
  ...config.api,
  paramsSerializer: params => {
    return qs.stringify(params)
  }
})

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

  api.interceptors.request.use(function (requestConfig) {
    if (!empty(config.theme.branding)) {
      requestConfig.headers['x-branding'] = config.theme.branding
    }
    if (!empty(i18n.global.locale)) {
      if (typeof requestConfig.params !== 'object' || requestConfig.params === null) {
        requestConfig.params = {}
      }
      requestConfig.params.l = i18n.global.locale
    }
    return requestConfig
  })
})

export { api }
